import React  from 'react';
import PropTypes from 'prop-types';
import { PricedStatus } from 'types';

import { RadioGroup } from '@bettercomp/ui-components';

export const PRICING_OPTIONS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  unpriced: { value: PricedStatus.UNPRICED, label: 'Unpriced' },
};

export const PRICING_OPTIONS_MASS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  noCuts: { value: PricedStatus.NO_CUTS, label: 'No Cuts' },
};


export const PricingStatusSelector = ({ onChange, isMass, ...props }) => {
  const handleChange = (event, value) => {
    onChange(value);
  };

  return (
    <div data-testid="pricingStatusSelector">
      <RadioGroup
        options={Object.values(isMass ? PRICING_OPTIONS_MASS : PRICING_OPTIONS)}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
};

PricingStatusSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};
